import { render, staticRenderFns } from "./videoSession.vue?vue&type=template&id=47c5e15a&scoped=true"
import script from "./videoSession.vue?vue&type=script&lang=js"
export * from "./videoSession.vue?vue&type=script&lang=js"
import style0 from "./videoSession.vue?vue&type=style&index=0&id=47c5e15a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c5e15a",
  null
  
)

export default component.exports